import Vue from 'vue';
import merge from '@/utils/merge';
import hour2happyVue from './hour2happy.vue';
let hour2happyConstructor = Vue.extend(hour2happyVue);
const defaults = {
	data: []
};
const Hour2happy = (options) => {
	options = merge({}, defaults, options);
	let instance = new hour2happyConstructor({
		data: options
	});
	instance._vm = instance.$mount();
	instance._el = instance.$el;
	instance._instance = instance;
	document.body.appendChild(instance.$el); // 把生成的提示的dom插入body中
	return instance;
};
export default Hour2happy;
